import styled from 'styled-components';
import { getUnderLineBgColor } from './helper/colors';

const Underline = styled.div`
  height: 1px;
  position: relative;
  margin-top: 12px;
  background-color: ${({ theme }) => theme.colors.elementLine};
  &:before {
    content: '';
    transition: 0.4s ease all;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 0;
    height: 2px;
    ${props => getUnderLineBgColor(props)}
    ${props =>
      (props.showUnderline ||
        props.showErrorMessage ||
        props.showSuccessMessage) &&
      `width: 100%;`}
  }
`;

export default Underline;
